import { useEffect, useState } from 'react';

export type CopyState = 'idle' | 'copied' | 'failed';

const COPIED_FOR_MS = 3000;

/** Copies `value`, showing `copied` for a few seconds; without a secure context there is no navigator.clipboard, and the throw lands in `failed`. */
export const useCopy = (value: string) => {
  const [copyState, setCopyState] = useState<CopyState>('idle');

  useEffect(() => {
    if (copyState !== 'copied') return;
    const reset = setTimeout(() => setCopyState('idle'), COPIED_FOR_MS);
    return () => clearTimeout(reset);
  }, [copyState]);
  const copy = () =>
    Promise.resolve()
      .then(() => navigator.clipboard.writeText(value))
      .then(
        () => setCopyState('copied'),
        () => setCopyState('failed'),
      );
  return { copyState, copy };
};
